import React from "react";
import classNames from "classnames";
import { SwitchProps } from ".";

export const Switch: React.FunctionComponent<SwitchProps> = ({
  value,
  onChange,
  labelOn,
  labelOff,
  style,
  containerStyle,
  size = "md",
  disabled = false,
}) => {
  const baseClasses = {
    switchSmall: "switch--small",
    disabled: "switch--disabled",
  };

  const propsClass = {
    [baseClasses.switchSmall]: size === "sm",
    [baseClasses.disabled]: disabled,
  };

  const switchClass = classNames("switch", propsClass, { "is-active": value });

  return (
    <div style={containerStyle}>
      <label className={switchClass} style={style}>
        <input
          type="checkbox"
          checked={!!value}
          onChange={onChange}
          disabled={disabled}
        />
        <span className="switch-slider text-label-sm">
          {value ? labelOn : labelOff}
        </span>
      </label>
    </div>
  );
};
